module.exports = __webpack_public_path__ + "Assets/Images/templates/thumbnails/Podcast-Marketing-Proposal.jpg";